import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { decryptIfEncrypted } from "../../../utils/fieldDecryptor";
import DialogContentText from "@material-ui/core/DialogContentText";
import { SCButtonAddInput } from "../../../components/Buttons/styles";
import { editCompany, getCountries, saveCompany } from "../../../store/middleware";

import { User } from "./styles";

function CompanyForm({ selectedCompany, setShowCompanyForm, setSelectedCompany }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { economicGroups } = useSelector((state) => state.b2bCompaniesReducer);

  const [id, setId] = useState(0);
  const [address, setAdress] = useState("");
  const [active, setActive] = useState(true);
  const [countryId, setCountryId] = useState(0);
  const [countries, setCountries] = useState([]);
  const [socialName, setSocialName] = useState("");
  const [alerttitle, setAlertTitle] = useState("");
  const [openalert, setOpenAlert] = useState(false);
  const [fantasyName, setFantasyName] = useState("");
  const [registerDate, setRegisterDate] = useState("");
  const [documentNumber, setDocumentNumber] = useState("");
  const [economicGroupId, setEconomicGroupId] = useState(0);
  const [alertdescription, setAlertDescription] = useState("");
  const [companyResponsibleContacts, setCompanyResponsibleContacts] = useState([]);
  const [generalState, setGeneralState] = useState({
    showDialog2: false,
    showDialog: false,
    alertMessage: "",
    loading: false,
    redirect: false,
    success: false,
    selectedPlan: null,
    plans: [],
    level: "",
  });

  const loadInfos = () => {
    dispatch(getCountries()).then((res) => setCountries(res));
  };

  useEffect(() => {
    loadInfos();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (selectedCompany && selectedCompany.id > 0 && selectedCompany.id !== id) {
      setCompanyResponsibleContacts(selectedCompany.companyResponsibleContacts);
      setActive(selectedCompany.active);
      setId(selectedCompany.id);
      setSocialName(selectedCompany.socialName);
      setFantasyName(selectedCompany.fantasyName);
      setDocumentNumber(selectedCompany.documentNumber);
      setCountryId(selectedCompany.countryId);
      setEconomicGroupId(selectedCompany.economicGroupId);
      setAdress(decryptIfEncrypted(selectedCompany.address));
      setRegisterDate(selectedCompany.registerDate);
    }
    // eslint-disable-next-line
  }, []);

  const addField = (e) => {
    e.preventDefault();

    setCompanyResponsibleContacts((state) => [
      ...state,
      {
        name: "",
        email: "",
        commercialPhone: "",
        mobilePhone: "",
      },
    ]);
  };

  const removeField = (e, findIndex) => {
    e.preventDefault();

    setCompanyResponsibleContacts(companyResponsibleContacts.filter((value, index) => index !== findIndex));
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = name === "active" ? !active : e.target.value;

    switch (name) {
      case "economicGroupId":
        setEconomicGroupId(value);
        break;
      case "socialName":
        setSocialName(value);
        break;
      case "fantasyName":
        setFantasyName(value);
        break;
      case "documentNumber":
        setDocumentNumber(value);
        break;
      case "address":
        setAdress(value);
        break;
      case "countryId":
        setCountryId(value);
        break;
      case "registerDate":
        setRegisterDate(value);
        break;

      default:
        break;
    }
  };

  const handleBack = () => {
    setCompanyResponsibleContacts([]);
    setActive(true);
    setId(0);
    setSocialName("");
    setFantasyName("");
    setDocumentNumber("");
    setCountryId(0);
    setEconomicGroupId(0);
    setAdress("");
    setRegisterDate("");
    setShowCompanyForm(false);
    setSelectedCompany(null);
  };

  const handleChangeContact = async (e, index) => {
    e.preventDefault();
    e.persist();

    setCompanyResponsibleContacts((state) =>
      state?.map((item, i) => (i === index ? { ...item, [e?.target?.name]: e.target.value } : item)),
    );
  };

  const validateForms = () => {
    if (economicGroupId === 0) {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("ECONOMIC_GROUP") }));

      return false;
    } else if (socialName.trim() === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("LEGAL_NAME") }));

      return false;
    } else if (fantasyName.trim() === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("COMPANY_NAME") }));

      return false;
    } else if (documentNumber.trim() === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("DOCUMENT_NUMBER") }));

      return false;
    } else if (address.trim() === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("ADDRESS") }));

      return false;
    } else if (countryId === 0) {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("COUNTRY") }));

      return false;
    } else if (registerDate === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("DATE") }));

      return false;
    } else if (companyResponsibleContacts.length === 0) {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("CONTACTS") }));

      return false;
    } else return true;
  };

  const handleSubmit = async () => {
    const req = {
      id: "",
      active: "",
      countryId: "",
      economicGroupId: "",
      socialName: "",
      fantasyName: "",
      documentNumber: "",
      address: "",
      registerDate: "",
      companyResponsibleContacts: "",
    };

    req.active = active;
    req.countryId = parseInt(countryId);
    req.economicGroupId = parseInt(economicGroupId);
    req.socialName = socialName;
    req.fantasyName = fantasyName;
    req.documentNumber = documentNumber;
    req.address = address;
    req.registerDate = registerDate;

    const contacts = companyResponsibleContacts || [];
    const contactsWithoutId = contacts.map((item) => {
      return {
        name: item.name,
        email: item.email,
        commercialPhone: item.commercialPhone,
        mobilePhone: item.mobilePhone,
      };
    });
    req.companyResponsibleContacts = contactsWithoutId.length > 0 && contactsWithoutId;

    if (validateForms()) {
      try {
        if (id && id > 0) {
          req.id = id;
          await dispatch(editCompany(req));
          setGeneralState({
            ...generalState,
            showDialog2: true,
            showDialog: false,
            showAddStudentForm: false,
            redirect: false,
            success: true,
          });
        } else {
          delete req.id;
          await dispatch(saveCompany(req));
          setGeneralState({
            ...generalState,
            showDialog2: true,
            showDialog: false,
            showAddStudentForm: false,
            redirect: false,
            success: true,
          });
        }
      } catch (err) {
        if (err.response.data && err.response.data.error && err.response.data.error.message) {
          if (err.response.data.error.message.indexOf("The maximum students per plan limit reached") !== -1) {
            setGeneralState({
              ...generalState,
              showDialog2: false,
              showDialog: true,
              alertMessage: t("MAXIMUM_STUDENTS"),
              redirect: false,
              success: false,
            });
          } else {
            setGeneralState({
              ...generalState,
              showDialog2: false,
              showDialog: true,
              alertMessage: err.response.data.error,
              redirect: false,
              success: false,
            });
          }
        } else {
          setGeneralState({
            ...generalState,
            showDialog2: false,
            showDialog: true,
            alertMessage: err.response.data.error,
            redirect: false,
            success: false,
          });
        }
      }
    }
  };

  const { showDialog2, showDialog, alertMessage } = generalState;

  return (
    <User>
      <Dialog
        open={showDialog2}
        onClose={() =>
          setGeneralState({
            ...generalState,
            showDialog2: false,
          })
        }
        className="alert-dialog-slide boxModal"
      >
        <DialogTitle className="alert-dialog-slide-title boxModal">
          {!id ? t("MESSAGE_SAVE") : t("MESSAGE_EDIT")}
        </DialogTitle>

        <DialogActions className="alert-dialog-slide-actions boxModal">
          <button type="button" className="btn-back" onClick={handleBack}>
            {"Back"}
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showDialog}
        onClose={() =>
          setGeneralState({
            ...generalState,
            showDialog: false,
          })
        }
        className="alert-dialog-slide boxModal"
      >
        <DialogTitle className="alert-dialog-slide-title boxModal">{t("SOMETHING_WENT_WRONG")}</DialogTitle>
        <DialogContent className="alert-dialog-slide-content boxModal">{t(alertMessage)}</DialogContent>
        <DialogActions className="alert-dialog-slide-actions boxModal">
          <button
            className="new-button close"
            onClick={() =>
              setGeneralState({
                ...generalState,
                showDialog: false,
              })
            }
          >
            {t("OK")}
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openalert}
        className="boxModal"
        onClose={() => setOpenAlert(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <span className="titleModal">{alerttitle}</span>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="pass-dialog-description" className="boxModal">
            <span className="formulario">
              <span className="description">{alertdescription}</span>
            </span>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <div className="buttons">
            <button onClick={() => setOpenAlert(false)} color="primary" autoFocus>
              {t("CLOSE")}
            </button>
          </div>
        </DialogActions>
      </Dialog>

      <div className="bigBox bigBoxForm" style={{ paddingLeft: "100px" }}>
        <h2>{id ? t("EDIT_COMPANY") : t("ADD_NEW_COMPANY")}</h2>

        <form className="formulario" onSubmit={handleSubmit}>
          <div className="lineInputs">
            <div>
              <label>{t("ECONOMIC_GROUP")}</label>
              <span>{t("REQUIRED")}</span>
            </div>
            <select value={economicGroupId} onChange={handleChange} className="input-lingo" name="economicGroupId">
              <option>Select</option>
              {economicGroups?.map((item) => {
                return (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="lineInputs">
            <div>
              <label>{t("LEGAL_NAME")}</label>
              <span>{t("REQUIRED")}</span>
            </div>
            <input type="text" name="socialName" value={socialName} onChange={handleChange} />
          </div>
          <div>
            <div>
              <label>{t("COMPANY_NAME")}</label>
              <span>{t("REQUIRED")}</span>
            </div>
            <input type="text" name="fantasyName" value={fantasyName} onChange={handleChange} />
          </div>
          <div>
            <div>
              <label>{t("DOCUMENT_NUMBER")}</label>
              <span>{t("REQUIRED")}</span>
            </div>
            <input type="text" name="documentNumber" value={documentNumber} onChange={handleChange} />
          </div>
          <div>
            <div>
              <label>{t("ADDRESS")}</label>
              <span>{t("REQUIRED")}</span>
            </div>
            <input type="text" name="address" value={address} onChange={handleChange} />
          </div>
          <div className="lineInputs">
            <div>
              <label>{t("COUNTRY")}</label>
              <span>{t("REQUIRED")}</span>
            </div>
            <select value={countryId} onChange={handleChange} className="input-lingo" name="countryId">
              <option>Select</option>
              {countries?.map((item) => {
                return (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="lineInputs">
            <div>
              <label>{t("DATE")}</label>
              <span>{t("REQUIRED")}</span>
            </div>
            <input type="date" name="registerDate" value={registerDate} onChange={handleChange} />
          </div>

          <div className="lineInputs period">
            <label>{t("CONTACTS")}</label>
            <div className="lingos">
              <div className="lingoSelects">
                <div className="linha"></div>
                <div className="selects">
                  <div className="delet">
                    <div>
                      {companyResponsibleContacts?.map((item, index) => {
                        return (
                          <div key={index * 7}>
                            <div>
                              {t("CONTACT")} #{index + 1}
                              <SCButtonAddInput
                                name="remove"
                                type="button"
                                data-index={index}
                                onClick={(e) => removeField(e, index)}
                                style={{ marginLeft: "12px" }}
                              >
                                Delete <i className="fa fa-times-circle-o" aria-hidden="true" />
                              </SCButtonAddInput>
                            </div>

                            <div className="lineInputs">
                              <div>
                                <label>{t("NAME")}</label>
                                <span>{t("REQUIRED")}</span>
                              </div>
                              <input
                                type="text"
                                name="name"
                                data-index={index}
                                className={`name_${index}`}
                                value={decryptIfEncrypted(item.name)}
                                onChange={(e) => handleChangeContact(e, index)}
                              />
                            </div>
                            <div className="lineInputs">
                              <div>
                                <label>{t("EMAIL")}</label>
                                <span>{t("REQUIRED")}</span>
                              </div>
                              <input
                                type="text"
                                className={`email_${index}`}
                                name="email"
                                data-index={index}
                                value={decryptIfEncrypted(item.email)}
                                onChange={(e) => handleChangeContact(e, index)}
                              />
                            </div>
                            <div className="lineInputs">
                              <div>
                                <label>{t("TELEPHONE_COMMERCIAL")}</label>
                                <span>{t("REQUIRED")}</span>
                              </div>
                              <input
                                type="text"
                                className={`commercialPhone_${index}`}
                                name="commercialPhone"
                                data-index={index}
                                value={item.commercialPhone}
                                onChange={(e) => handleChangeContact(e, index)}
                              />
                            </div>
                            <div className="lineInputs">
                              <div>
                                <label>{t("TELEPHONE_MOBILE")}</label>
                                <span>{t("REQUIRED")}</span>
                              </div>
                              <input
                                type="text"
                                className={`mobilePhone_${index}`}
                                name="mobilePhone"
                                data-index={index}
                                value={item.mobilePhone}
                                onChange={(e) => handleChangeContact(e, index)}
                              />
                            </div>
                          </div>
                        );
                      })}
                      <div>
                        <SCButtonAddInput onClick={(e) => addField(e)}>{t("BTN_ADD_NEW_CONTACT")} +</SCButtonAddInput>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <label>Status</label>
            <div className="switchBox">
              <div className="switch__container">
                <input
                  id="switch-shadow"
                  className="switch switch--shadow"
                  name="active"
                  type="checkbox"
                  checked={active}
                  onChange={handleChange}
                />
                <label htmlFor="switch-shadow">
                  <span style={{ marginLeft: "50px", fontSize: "12px" }}>{active ? "Active" : "Inactive"}</span>
                </label>
              </div>
            </div>
          </div>

          {/* {id > 0 && (
            <button type="button" className="deleteLast" onClick={handleDelete}>
              {t("DELETE")} {t("COMPANY")}
            </button>
          )} */}
        </form>
      </div>

      <div className="form-buttons">
        <button type="button" className="btn-back" onClick={handleBack}>
          <i className="fa fa-angle-left" aria-hidden="true"></i>
          {t("BTN_BACK")}
        </button>
        <button type="submit" className="btn-save" onClick={handleSubmit}>
          {t("SAVE")}
        </button>
      </div>
    </User>
  );
}

export default CompanyForm;
